/**
 * Card scheme detection helper
 */

export function isMastercard(design) {
  if (design && (String(design).includes('mastercard') || String(design).includes('mc'))) {
    return true;
  }
  const firstDigit = localStorage.getItem('first-digit');
  return firstDigit === '5' || firstDigit === '2';
}

export function getCardSchemeName(design) {
  return isMastercard(design) ? 'Mastercard' : 'Visa';
}
